import { render, staticRenderFns } from "./dr-content-header-component.vue?vue&type=template&id=485cf504&"
import script from "./dr-content-header-component.vue?vue&type=script&lang=js&"
export * from "./dr-content-header-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports